module.exports = __webpack_public_path__ + "img/MapPicsFourLakes.ea1640fd.webp";